module.exports = require('./lib/dom-scroll-into-view');



//////////////////
// WEBPACK FOOTER
// ./~/react-autocomplete/~/dom-scroll-into-view/index.js
// module id = 2236
// module chunks = 0